import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-57d7a6ab"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "tw-flex tw-select-none" };
const _hoisted_2 = { class: "tw-flex-none" };
const _hoisted_3 = ["title"];
const _hoisted_4 = { class: "tw-text-h2 tw-text-secondary" };
const _hoisted_5 = { class: "friss-score-info tw-overflow-hidden tw-py-2 tw-pl-4 tw-text-secondary" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "tw-text-subtitle-1 tw-truncate" }, "FRISS Score ®", -1));
const _hoisted_7 = ["title"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
                class: "tw-border-current tw-flex tw-h-16 tw-w-16 tw-items-center tw-justify-center tw-rounded-full tw-border-4 tw-text-center",
                style: _normalizeStyle({ color: _ctx.color }),
                title: _ctx.score?.toString(),
                "data-test-id": "friss-score-circle"
            }, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.formattedScore), 1)
            ], 12, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", {
                class: "tw-text-body-2 tw-truncate",
                title: _ctx.description
            }, _toDisplayString(_ctx.description), 9, _hoisted_7)
        ])
    ]));
}
